var React = require('react');

function Reit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M673.88,434.31,502,261.26l-.68-.65a49.47,49.47,0,0,0-66-.14c-.23.21-.46.42-.68.65L261.14,434.26a16.5,16.5,0,0,0,23.31,23.36l13.09-13.07V587a66.08,66.08,0,0,0,66,66h59.4a16.5,16.5,0,0,0,16.5-16.5V502h57.75V636.5a16.5,16.5,0,0,0,16.5,16.5h57.75a66.08,66.08,0,0,0,66-66,16.5,16.5,0,0,0-33,0,33,33,0,0,1-33,33H530.18V485.53a16.5,16.5,0,0,0-16.5-16.5H422.94a16.5,16.5,0,0,0-16.5,16.5V620h-42.9a33,33,0,0,1-33-33V411.62l127-126.75a16.5,16.5,0,0,1,21.41,0L604.43,411.22v93.29a16.5,16.5,0,1,0,33,0V444.44l13,13.13a16.5,16.5,0,0,0,23.41-23.26Z","transform":"translate(-256.29 -247.92)","fill":"#fff"}));
}

Reit.defaultProps = {"viewBox":"0 0 422.34 405.08"};

module.exports = Reit;

Reit.default = Reit;
